module.exports = __webpack_public_path__ + "img/Turkey.51192e96.png";